import React, { useState } from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { getApi, postApi } from '../../../../api/call.api';
import { urlApi } from '../../../../api/url.api';
import { toast } from 'sonner';
import { IconNotes, IconTrash } from '@tabler/icons-react';
import { dateTimeConverter } from '../../../../utils/dateTimeConverter';
import ConfirmationModal from '../../../../components/ConfirmationModal/ConfirmationModal';
import { loadingHide, loadingShow } from '../../../../loadingUi/loading.controller';

const VisitorNoteSidebar = ({ visitorData }) => {
    const [show, setShow] = useState(false);
    const [noteList, setNoteList] = useState([]);
    const [loading, setLoading] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleAddNote = async () => {
        loadingShow();
        let postData = {
            chatSessionId: visitorData?._id,
            noteText: document.getElementById('noteText').value,
        }
        if (!postData.noteText) {
            toast.error("Please enter a note");
            return;
        }
        let resp = await postApi(postData, urlApi.addVisitorNoteInChat);
        loadingHide();
        if (resp?.responseCode === 200) {
            document.getElementById('noteText').value = "";
            getNoteList();
            toast.success("Note added successfully");
        } else {
            toast.error("Failed to add note");
        }
    }

    const getNoteList = async () => {
        loadingShow();
        setLoading(true);
        let resp = await getApi(urlApi.getVisitorNoteList + visitorData?._id);
        setLoading(false);
        loadingHide();
        handleShow();
        if (resp?.responseCode === 200) {
            setNoteList(resp?.data || []);
        } else {
            setNoteList([]);
        }
    }

    const handleDeleteNote = async (noteId) => {
        let resp = await getApi(urlApi.deleteVisitorNote + noteId);
        if (resp?.responseCode === 200) {
            toast.success("Note deleted successfully");
            setNoteList(noteList.filter(item => item._id !== noteId));
        } else {
            toast.error("Failed to delete note");
        }
    }

    return (
        <>
            <button className='p-1.5 bg-slate-200 hover:bg-gray-100 text-xs rounded-full hover:text-gray-500 hover:cursor-pointer text-gray-700 transition' onClick={getNoteList} title='Visitor Notes'>
                <IconNotes size={20} />
            </button>

            <Offcanvas show={show} onHide={handleClose} placement='end'>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title as={'h4'}>Visitor Notes</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className='mb-2'>
                        <label htmlFor="noteText" className='text-sm font-semibold mb-1'>Note*</label>
                        <textarea type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='' id='noteText' rows={3} ></textarea>
                    </div>
                    <div className='text-end'>
                        <button className='!bg-primary text-white px-4 py-2 rounded-md text-xs font-semibold' onClick={() => handleAddNote()}>Add Note</button>
                    </div>

                    <hr className='my-2' />

                    <div>
                        {loading ? <p className='text-center text-sm'>Loading...</p> : noteList.length > 0 ? noteList.map((item, index) => (
                            <div key={index} className='flex justify-between items-center border-b py-2'>
                                <div>
                                    <p className='text-sm mb-1'>{item?.noteText}</p>
                                    <p className='text-xs text-gray-500'>{dateTimeConverter(item?.createdAt)}</p>
                                </div>
                                <ConfirmationModal buttonComponent={<button className='text-red-500'><IconTrash size={20} /></button>} confirmationText={"Are you sure want to delete this note?"} onConfirm={() => handleDeleteNote(item?._id)} />

                            </div>
                        )) : <p className='text-center text-sm'>No notes found</p>}
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}

export default VisitorNoteSidebar